import { render, staticRenderFns } from "./DHLForm.vue?vue&type=template&id=1bd42e42&scoped=true"
import script from "./DHLForm.vue?vue&type=script&lang=js"
export * from "./DHLForm.vue?vue&type=script&lang=js"
import style0 from "./DHLForm.vue?vue&type=style&index=0&id=1bd42e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd42e42",
  null
  
)

export default component.exports